module.exports = __webpack_public_path__ + "img/hackenproof_image_presentation.ed6a8a9d.webp";